
scopeOptions = ['everyone', 'ybusa', 'program']
scopeOptions.everyone = 'Everyone'
scopeOptions.ybusa = 'YouthBuild Global Staff and Coaches'
scopeOptions.program = 'Program Staff'


ChangeLogService = ($http, ApiUrl, momentConvertFilter, moment, $templateCache) ->
    'ngInject'
    
    service = @
    root_url = ApiUrl.partial('change_log')
    @scopeOptions =scopeOptions

    @getAuthors = ->
        return $http.get(root_url('authors'))
            .then (response) ->
                ids = []
                ids.names = {}
                for staff in response.data.items
                    ids.push staff.id
                    ids.names[staff.id] = staff.name
                return ids

    @index = (params={}) ->

        return $http.get(root_url(), params: params)
            .then responseItems
            .then momentConvertFilter

    @get = (id) ->
        return $http.get(root_url(id))
            .then responseItem
            .then momentConvertFilter

    @templateUrl = (change) ->
        change_id = change.id or change
        return root_url(change_id, 'template.html')

    @create = (data) ->
        combinePublishedDate(data)
        return $http.post(ApiUrl('change_log'), data)
            .then responseItem
            .then momentConvertFilter

    @patch = (item, data) ->
        combinePublishedDate(data)
        return $http.patch(root_url(item.id), data)
            .then responseItem
            .then momentConvertFilter
            .then (newData) ->
                $templateCache.remove(service.templateUrl(item))
                angular.copy(newData, data)
                return data

    @delete = (item) ->
        return $http.delete(root_url(item.id))

    combinePublishedDate = (data) ->
        if not data.published? and data.published_date? and data.published_time?
            date = moment(data.published_date)
            date.hour(data.published_time.hour())
            date.minute(data.published_time.minute())
            date.startOf('minute')
            data.published = date
        return data

    return

responseItem = (r) -> r.data.item
responseItems = (r) -> r.data.items

module.service 'ChangeLogService', ChangeLogService
